// Quarterly OKR — the coach's REST surface (§9, §12). Every route takes the
// quarter row id (`:quarterCompanyId`), not the run id — coach links and
// emails carry the quarter (§18.1).
const BASE = "/coach/quarterly-okr";
const quarter = (quarterCompanyId) => `${BASE}/${quarterCompanyId}`;

export const QOKR_URLS = {
  // §9.1 — up to 3 latest AI quarters per client.
  DASHBOARD: `${BASE}/dashboard`,

  // §9.3 — `enter` is a no-op once the review is in progress.
  REVIEW_ENTER: (qcId) => `${quarter(qcId)}/review/enter`,
  REVIEW: (qcId) => `${quarter(qcId)}/review`,
  REVIEW_STATUS: (qcId, type, objectiveId) =>
    `${quarter(qcId)}/review/objectives/${type}/${objectiveId}/status`,
  REVIEW_COMMENTS: (qcId) => `${quarter(qcId)}/review/comments`,
  REVIEW_COMMENT: (qcId, commentId) =>
    `${quarter(qcId)}/review/comments/${commentId}`,
  REVIEW_SUBMIT: (qcId) => `${quarter(qcId)}/review/submit`,

  // Handoff 34 — the AI coach brief. GET works in every state; regenerate
  // answers `{ status: "IN_PROGRESS" }` and the screen polls the GET.
  BRIEF: (qcId) => `${quarter(qcId)}/brief`,
  BRIEF_REGENERATE: (qcId) => `${quarter(qcId)}/brief/regenerate`,

  // §9.5
  LIVE_REVIEW_START: (qcId) => `${quarter(qcId)}/live-review/start`,

  // §12
  SUMMARY: (qcId) => `${quarter(qcId)}/summary`,

  // The locked quarter's scorecard — the coach's read-only twin of the CEO's
  // §11 `GET /quarterly-okr/:uniqueId/tracking`, same shape (key results carry
  // `progress` too), every `can_edit_*` false. Confirmed in handoff 32 §1.2.
  TRACKING: (qcId) => `${quarter(qcId)}/tracking`,
};
